import { render, staticRenderFns } from "./CreateBPInstance.vue?vue&type=template&id=1b3dda82&"
import script from "./CreateBPInstance.vue?vue&type=script&lang=js&"
export * from "./CreateBPInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports